"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContainerDoInput = exports.ContainerDoCampo = void 0;
var rebass_1 = require("rebass");
var react_1 = __importDefault(require("react"));
var tema_1 = require("../../tema");
var ContainerDoCampo = function (props) {
  return react_1.default.createElement(rebass_1.Box, __assign({
    sx: {
      ".mensagem-de-erro": {
        mt: 1
      }
    }
  }, props));
};
exports.ContainerDoCampo = ContainerDoCampo;
var ContainerDoInput = function (props) {
  return react_1.default.createElement(rebass_1.Flex, __assign({
    sx: {
      "--cor-da-fonte": tema_1.colors.gray4,
      "--raio-da-borda": "4px",
      alignItems: "center",
      background: "white",
      borderWidth: 1,
      borderColor: "var(--cor-da-fonte)",
      borderStyle: "solid",
      borderRadius: "var(--raio-da-borda)",
      "&:focus-within": {
        "--cor-da-fonte": tema_1.colors.blue1
      },
      "&.com-erro": {
        "--cor-da-fonte": tema_1.colors.negativo
      },
      "& .icone-de-status": {
        mr: 2
      },
      input: {
        paddingY: 2,
        paddingX: 3,
        fontSize: 1,
        width: "100%",
        border: "none",
        borderRadius: "var(--raio-da-borda)",
        color: "blue1",
        outline: "none",
        fontFamily: "heading",
        "&:-webkit-autofill, &:-webkit-autofill:focus, &:-webkit-autofill:hover": {
          boxShadow: "0 0 0px 1000px #FFF inset"
        },
        "::placeholder": {
          color: "var(--cor-da-fonte)"
        }
      }
    }
  }, props));
};
exports.ContainerDoInput = ContainerDoInput;